export default {
  PUSHER_APP_ID: '1508951',
  PUSHER_APP_KEY: '1eac913b2043d18601f4',
  PUSHER_SECRET_KEY: '5a5ecea7db1bae877f23',
  ONESIGNAL_APP_KEY: `48a430e9-3d5f-4180-afd7-81667f02dc36`,
  CLIENT_URL: 'https://api.qbicyard.com',
  MEDIA_URL: 'https://api.qbicyard.com',
  // API_URL: 'https://api.qbicyard.com',
  API_URL: 'https://d3hpa6816n13m2.cloudfront.net',
};
